import React from 'react'
import { string, func } from 'prop-types'
import classNames from 'classnames'
import Label from './label'

const Input = ({
  label,
  placeholder,
  fieldName,
  type,
  value,
  onValueChange,
  errorMessage
}) => {
  const containerClasses = classNames('nft-field', { 'has-error': !!errorMessage })
  return (
    <div className={containerClasses}>
      {label && <Label text={label} labelFor={`user-${fieldName}`} />}
      <input
        className='afd-textfield__input'
        placeholder={placeholder}
        id={`user-${fieldName}`}
        type={type}
        name={fieldName}
        value={value}
        onChange={e => onValueChange(e.currentTarget.value)}
        data-insights-funnel-step={fieldName} />
      {errorMessage && <p className='nft-error-msg'>{errorMessage}</p>}
    </div>
  )
}

Input.propTypes = {
  label: string,
  placeholder: string,
  fieldName: string,
  type: string,
  value: string,
  onValueChange: func.isRequired,
  errorMessage: string
}

export default Input